module.exports = __webpack_public_path__ + "img/mic11.81355d25.jpg";